import { createSignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';

export const playingContentIdVar = createSignal<string | null>(null);
export const usePlayingContentIdVar = () => useSignal(playingContentIdVar);
